window.addEventListener('load', () => {
  const inputs = document.querySelectorAll('.c-selection');

  inputs.forEach(input => {
    input.addEventListener('click', function () {
      if (this.checked) {
        // remove all selected classes
        const parent = this.parentNode.parentNode.parentNode;
        const children = parent.querySelectorAll('.input-parent');

        for (const element of children) {
          element.querySelector('label').classList.remove('border-blue-500');
          element.querySelector('label').classList.remove('text-blue-500');
        }

        // add selected class to the selected element
        this.parentNode.classList.add('border-blue-500');
        this.parentNode.classList.add('text-blue-500');

        // remove message when selected
        const error = parent.querySelector('.error-message');

        if (error) {
          error.classList.add('hidden');
        }
      }
    });
  });
});
